import { reactive, h } from 'vue'
import { createWebHashHistory, createRouter, RouterView } from 'vue-router'

import base from '../config/base'
/**
 * @type {import('node_modules/vue-router/dist/vue-router').RouteRecord[]}
 */
export const routes = [
  {
    path: '/',
    redirect: to => {
      return { path: '/YNAP' }
    }
  },
  {
    path: '/:provider(AEM|YNAP|BAOZUN|MNP)',
    props: true,
    component: { render: () => h(RouterView) },
    children: [
      {
        name: 'Home',
        path: '',
        component: () => import('./pages/HomePage.vue')
      },
      {
        name: 'Wizard',
        path: 'wizard',
        component: () => import('./pages/WizardPage.vue')
      }
    ]
  },
  {
    // matches /anyroute (if not found) and redirects it to /
    // https://next.router.vuejs.org/guide/migration/#removed-star-or-catch-all-routes
    path: '/:pathMatch(.*)*',
    // flag this route as a 404 page
    // so that (optional) internationalization can replace
    // this with its own implementation
    meta: reactive({ is404: true }),
    redirect: to => {
      return { path: '/' }
    }
  }
]
/**
 * A default naive implementation of a scrollbehavior
 * @param {import('node_modules/vue-router/dist/vue-router').RouteRecord} to
 * @param {import('node_modules/vue-router/dist/vue-router').RouteRecord} from
 * @param {{x:number, y:number}} savedPosition
 * @returns {{x:number, y:number}} where to scroll
 */
const defaultScrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return savedPosition
  } else {
    return { x: 0, y: 0 }
  }
}
/**
 * local route loading timeout
 */
let routeloadingTimeout
/**
 * Returns a router instance with attached hooks for tracking page loads,
 * also accepts a custom scrollBehavior
 *
 * @param {import('node_modules/vue-router/dist/vue-router').RouteRecord[]} routes
 * @param {Function} scrollBehavior a custom scrollbehavior
 * @returns {import('node_modules/vue-router/dist/vue-router').Router}
 */
export const setupRouter = (routes, { scrollBehavior, addRouterHooks }) => {
  const router = createRouter({
    // Provide the history implementation to use
    // history: VueRouter.createWebHashHistory(),
    // or
    history: createWebHashHistory(base),
    routes, // short for `routes: routes`
    scrollBehavior: scrollBehavior || defaultScrollBehavior
  })

  addRouterHooks && addRouterHooks(router)

  router.beforeEach(async (to, from, next) => {
    // 100ms timeout
    routeloadingTimeout = setTimeout(() => {
      // console.log('route has been loading for more than 100ms, mark is as "loadingChunk"')
      if (!to.meta) to.meta = reactive({ loadingChunk: true })
      to.meta.loadingChunk = true
      if (!from.meta) from.meta = reactive({ loadingChunk: true })
      from.meta.loadingChunk = true
    }, 100)

    // if (from?.params?.provider) {
    //   debugger
    //   if (!to.params) to.params = {}
    //   to.params.provider = from.params.provider
    // }
    // console.time('route chunk loading time')
    next()
  })

  router.beforeResolve((to, from, next) => {
    clearTimeout(routeloadingTimeout)

    if (!to.meta) to.meta = reactive({ loadingChunk: false })
    to.meta.loadingChunk = false
    if (!from.meta) from.meta = reactive({ loadingChunk: false })
    from.meta.loadingChunk = false

    // console.timeEnd('route chunk loading time')
    next()
  })
  return router
}
